export default __webpack_public_path__ + "static/media/gripper.be04cb33.svg";